import type { ReactElement, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { OKTA_SSO_ROUTE_PREFIX } from 'common/auth/constants';

import { DEVICE_HANDOFF_PATH } from '../state/constants';
import { selectIsDeviceHandoffModalOpen, selectRespondentActivityLocation } from '../state/selectors';

interface DeviceHandoffRouteGateProps {
    children: ReactNode;
}

const isHandoffBoundaryPath = (pathname: string): boolean =>
    pathname === '/' || pathname.startsWith(DEVICE_HANDOFF_PATH);

export const DeviceHandoffRouteGate = ({ children }: DeviceHandoffRouteGateProps): ReactElement => {
    const isDeviceHandoffModalOpen = useSelector(selectIsDeviceHandoffModalOpen);
    const respondentActivityLocation = useSelector(selectRespondentActivityLocation);
    const { pathname } = useLocation();
    const isOktaCallbackRoute = pathname.startsWith(OKTA_SSO_ROUTE_PREFIX);

    if (isDeviceHandoffModalOpen && !pathname.startsWith(DEVICE_HANDOFF_PATH) && !isOktaCallbackRoute) {
        return <Navigate to={DEVICE_HANDOFF_PATH} replace />;
    }

    // The respondent must stay on their activity for the whole turn; a stray navigation to a handoff
    // boundary route (home / the handoff route) is bounced back to the current activity.
    if (respondentActivityLocation && !isOktaCallbackRoute && isHandoffBoundaryPath(pathname)) {
        return <Navigate to={respondentActivityLocation} replace />;
    }

    return <>{children}</>;
};
